import React from 'react';
import { StyledNavPropsButton, ValuePropsContainer, ValuePropsTextDesktop, ValuePropsTextMobile } from './ValuePropsStationery.styles';
import { Box } from '@components/Box';
import { useTranslation } from 'react-i18next';

interface ValuePropsStationeryProps {}

export const ValuePropsStationery: React.FC<ValuePropsStationeryProps> = () => {
  const { t } = useTranslation('header');

  return (
    <StyledNavPropsButton
      variant="defaultPrimary"
      id="value-props-stationery"
      forwardedAs="a"
      href={t('stationeryValueProps.link')}
      target="_blank"
    >
      <ValuePropsContainer alignItems="center">
        <ValuePropsTextDesktop as="p">{t('stationeryValueProps.titleDesktop')}</ValuePropsTextDesktop>
        <ValuePropsTextMobile as="p">{t('stationeryValueProps.titleMobile')}</ValuePropsTextMobile>
        <Box as="p" style={{ textDecoration: 'underline', textUnderlineOffset: '3px' }}>
          {t('stationeryValueProps.cta')}
        </Box>
      </ValuePropsContainer>
    </StyledNavPropsButton>
  );
};
